<template>
  <div>
    <PageHeader :title="update ? 'ویرایش قوانین' : 'اضافه کردن قوانین'" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="card mb-3 p-3">
          <div class="section-title mb-3">موضوع</div>
          <b-form-checkbox-group v-model="model.subjectIds" :options="model.subjects" value-field="id" text-field="name"></b-form-checkbox-group>
        </div>
        <div class="card p-3 mt-3 my-auto d-flex flex-row justify-content-between">
          <b-form-checkbox v-model="model.isDisplayable" class="pt-2">
            <div class="mx-1">نمایش قوانین</div>
          </b-form-checkbox>
          <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary">
            <i class="far fa-times-circle"></i>
            <span class="ms-2">حذف قوانین</span>
          </b-button>
        </div>
        <div class="inner__style">
          <div
            v-if="model.image.length === 0"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="(event) => (this.model.image.length ? event.preventDefault() : $refs.fileInput.click())"
          >
            <div>
              <i :class="['fas fa-cloud-upload-alt icon-size', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>
              <div class="upload-text-size">برای آپلود عکس خود کلیک کنید</div>
            </div>
            <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInput" />
          </div>
          <div v-else class="grand-parent">
            <div class="upload-photo-parent">
              <div class="uploaded-photo">
                <div class="remove-icon" @click="model.image = ''">
                  <i class="fa fa-times"></i>
                </div>
                <img class="previewImage" :src="model.image" />
              </div>
            </div>
          </div>
          <div class="my-3">
            <TextAreaInput rows="2" :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین" placeholder="متن جایگزین" />
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card">
          <Section title="اطلاعات قوانین">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.title" @input="model.title = $event" title="عنوان" placeholder="عنوان" />
            </div>
            <div>
              <EditorInput :value="model.description" @input="model.description = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.approvalReference" @input="model.approvalReference = $event" title="مرجع تصویب" placeholder="مرجع تصویب" />
            </div>
            <div class="my-3">
              <DateTimeOffset :value="model.approvalDate" @input="model.approvalDate = $event" title="تاریخ تصویب" placeholder="تاریخ تصویب" :hasDefaultDate="false" />
            </div>
          </Section>
        </div>
        <div class="card">
          <Section title="بارگزاری فایل">
            <div class="my-3">
              <UploadBox @fileBoxData="uploadedFile($event)" :componentData="url" :filesLength="1" placeholder="فایل خود را انتخاب کنید" />
            </div>
          </Section>
        </div>
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/ruleandregulation')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addRule">ثبت</b-button>
    </div>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف قوانین اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deleteRule">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
  </div>
</template>
<script>
import PageHeader from '../../layoutComponents/page-header.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import fileMannager from '../../../services/file'
import dadbanRuleProvider from '../../../services/dadban/rule'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import Section from '../../common/form/Section.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import UploadBox from '../../common/form/formModules/UploadBox.vue'
export default {
  name: 'AddRules',
  components: { PageHeader, BaseText, EditorInput, Toast, Loader, Section, TextAreaInput, DateTimeOffset, UploadBox },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imageCrop: { width: 400, height: 200 },
      model: {
        title: '',
        description: '',
        approvalReference: '',
        image: '',
        isDisplayable: true,
        approvalDate: '',
        url: '',
        urlName: '',
        urlType: '',
        subjectIds: [],
        subjects: [],
      },
      subjectOptions: [],
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      loading: false,
      url: [],
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت قوانین', active: true },
      ],
    }
  },
  watch: {
    'model.approvalDate'(c) {
      if (c && !c.includes('T') && c) {
        this.model.approvalDate = this.model.approvalDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    'model.url'(c) {
      if (c) {
        this.url = [
          {
            url: c,
            name: this.model.urlName,
            type: this.model.urlType,
          },
        ]
      }
    },
    model(c) {
      for (const key in c) {
        if (!c[key]) {
          this.model[key] = ''
        }
      }
    },
  },
  mounted() {
    if (!this.update) {
      this.getInputs()
    }
    if (this.update) {
      this.fetchRule()
      this.model = this.data
    }
  },
  methods: {
    onFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        this.uploadImage(e.target.result)
      }

      reader.readAsDataURL(file)
    },
    async addRule() {
      this.loading = true

      for (const key in this.model) {
        if (!this.model[key]) {
          delete this.model[key]
        }
      }
      try {
        delete this.model.subjects
        if (this.update) {
          const req = await dadbanRuleProvider.updateRule(this.model)
          if (req.status === 200) {
            this.message = 'ثبت با موفقیت انجام شد.'
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          this.loading = false
          return false
        }
        const req = await dadbanRuleProvider.addRule(this.model)
        if (req.status === 200) {
          this.message = 'ثبت با موفقیت انجام شد.'
          setTimeout(() => {
            this.$router.push('/list/ruleandregulation/detail/' + req.data.data)
          }, 2000)
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchRule() {
      this.loading = true
      try {
        const req = await dadbanRuleProvider.getRule(+this.$route.params.id)
        this.model = req.data.data.output
        this.model.subjectIds = []
        this.model.subjects.forEach((item) => {
          if (item.isActive) {
            this.model.subjectIds.push(item.id)
          }
        })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.model.image = req.data.data.downloadUrl
      this.cropperLoading = false
    },
    uploadedFile($event) {
      this.model.url = $event[0].url
      this.model.urlName = $event[0].name
      this.model.urlType = $event[0].type
    },
    async deleteRule() {
      this.loading = true
      try {
        const req = await dadbanRuleProvider.deleteRule(+this.$route.params.id)
        this.$bvModal.hide('deleteModal')
        if (req.status === 200) {
          this.$router.push('/list/ruleandregulation' + localStorage.getItem('query'))
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async getInputs() {
      const req = await dadbanRuleProvider.getInputs()
      this.model.subjects = req.data.data.output.map((item) => {
        item = { name: item.title, id: item.id }
        return item
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.sections {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 1rem;
}

.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  height: 122px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}
.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
}

::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .b-form-tags-button {
  display: none;
}
</style>
